import currentDomain  from '../Utils/Utils';
class ApiError extends Error {
    constructor(
        message: string,
        public status: number,
        public response?: Response
    ) {
        super(message);
        this.name = 'ApiError';
    }
}

class ApiClient {
    private baseUrl: string;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl;
    }

    private async request<T>(
        endpoint: string,
        options: RequestInit = {}
    ): Promise<T> {
        const url = `${this.baseUrl}/api${endpoint}`;
        
        const config: RequestInit = {
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
            ...options,
        };

        const response = await fetch(url, config);

        if (!response.ok) {
            throw new ApiError(
                `API Error: ${response.statusText}`,
                response.status,
                response
            );
        }

        // Handle empty responses
        const text = await response.text();
        if (!text) return {} as T;
        
        try {
            return JSON.parse(text);
        } catch {
            return text as unknown as T;
        }
    }

    
    async getSpecialAwards(): Promise<Array<{ id: number; name: string; description: string }>> {
        return this.request<Array<{ id: number; name: string; description: string }>>('/winners/awards');
    }


    async sendTextMessage(msgId: number, body: {owner_phone: string, year?: number, make?: string, model?: string}[]): Promise<void> {
        return this.request<void>(`/text/send/${msgId}`, {
            method: 'POST',
            body: JSON.stringify(body),
        });
    }
}

// Export singleton instance
export const apiClient = new ApiClient(currentDomain(window.location));
export { ApiClient, ApiError };